import type { Building } from "building-types/building/buildingTypes";
import type { GeneratedRoofFraming } from "building-types/framing/roofFramingTypes";
import type { BuildingGenerationIssue } from "building-types/settings/buildingGenerationIssue";
import type { RWTable } from "common/data/table";
import { buildRoofFraming } from "../elements/roofs/roofFraming";
import makeGenerationStageComparator from "../utils/makeGenerationStageComparator";
import memo from "../utils/memo";

function select({ roofSystems }: Pick<Building, "roofSystems">) {
  return {
    roofSystems,
  };
}

const compare = makeGenerationStageComparator<typeof select>({
  roofSystems: "shallow",
});

function generate({ roofSystems }: ReturnType<typeof select>): Pick<Building, "roofFraming" | "issues"> {
  const issues: BuildingGenerationIssue[] = [];
  const roofFraming: RWTable<GeneratedRoofFraming> = {};

  if (!roofSystems) {
    return { roofFraming, issues };
  }

  for (const roofId in roofSystems) {
    buildRoofFraming({
      roofSystem: roofSystems[roofId],
      roofFramingTableNew: roofFraming,
    });
  }
  return { roofFraming, issues };
}

export default memo(select, generate, compare);
